// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3UgNq","addWidgetButton":"Header_addWidgetButton__2DWup","dashboardTabs":"Header_dashboardTabs__tIUfM","active":"Header_active__3rzjX"};